import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/**
 * Wraps protected routes. After login, computes the customer's next onboarding step
 * and redirects them there until they've completed: OTP → profile → plan → admin approval → contract.
 */
export default function OnboardingGate({ children }) {
  const { user } = useAuth();
  const loc = useLocation();
  const [state, setState] = useState(null);

  useEffect(() => {
    if (!user) return;
    if (user.role === "admin") { setState({ next_step: "dashboard" }); return; }
    api.get("/onboarding/state").then((r) => setState(r.data)).catch(() => setState({ next_step: "dashboard" }));
  }, [user, loc.pathname]);

  if (!user) return <Navigate to="/login" replace />;
  if (!state) return <div className="min-h-screen bg-[#05050A] grid place-items-center text-white/40 text-sm">Loading…</div>;

  // Pages that are always OK while gated
  const ALWAYS = ["/onboarding/profile", "/onboarding/plan", "/onboarding/pending",
                    "/onboarding/contract", "/dashboard/billing", "/dashboard/support",
                    "/dashboard/profile"];

  const target = {
    verify_email: "/register",            // shouldn't happen post-login
    profile: "/onboarding/profile",
    choose_plan: "/onboarding/plan",
    pay: "/onboarding/plan",
    awaiting_admin_review: "/onboarding/pending",
    blocked: "/onboarding/pending",
    sign_contract: "/onboarding/contract",
    dashboard: null,  // allow through
  }[state.next_step] || null;

  if (target && !ALWAYS.includes(loc.pathname) && loc.pathname !== target) {
    return <Navigate to={target} replace />;
  }
  return children;
}
